import {observable, computed, action} from 'mobx';

class TableItemNotEmote {
    @observable name = '';
    id = '';
    @observable amount = 0;

    constructor(data = {}) {
        if (Object.keys(data).length > 0) {
        }
        this.name = data.name || data.hashtag || data.command;
        this.id = data.id;
        this.amount = data.amount;
    }
}

export default TableItemNotEmote;



// WEBPACK FOOTER //
// ./src/app/models/TableItemNotEmote.js